import React, { FC, useEffect } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { ServicesByDepartmentSectionContainer } from '../modules/services-by-departament-section/services-by-departament-section.container';

export const DepartmentSectionServices: FC = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <div>
        <ServicesByDepartmentSectionContainer />
      </div>
      <FooterContainer />
    </>
  );
};
